module.exports = __webpack_public_path__ + "static/media/0043_Medium.5e9cc87d.jpg";